export default (str: string) =>
  str
    .toLowerCase()
    .trim()
    // Replace spaces and non-word chars (except accented letters) with hyphens
    // Keep: a-z, 0-9, and accented characters (À-ÿ includes all common French characters)
    .replace(/[^a-z0-9\u00C0-\u00FF]+/g, '-')
    .replace(/^-+|-+$/g, ''); // Remove leading/trailing hyphens
